import React from "react";

function Close() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12.784 22.06c5.523 0 10-4.476 10-10 0-5.522-4.477-10-10-10s-10 4.478-10 10c0 5.524 4.477 10 10 10zM15.784 9.06l-6 6M9.784 9.06l6 6"
      ></path>
    </svg>
  );
}

export default Close;
